<template>
	<div class="form-group">
		<label :for="name" :class="{ error: errors.has(name) }">{{ placeholder }}</label>
		<input type="text" :autocomplete="autocomplete" :name="name" :id="name" v-model="model" v-validate="rules" :data-vv-as="placeholder" :placeholder="placeholder" class="form-control" :class="{ error: errors.has(name) }">
		<span v-if="rules" v-show="errors.has(name)" class="text-danger">{{ errors.first(name) }}</span>
	</div>
</template>

<script>
export default {
	inject: ['$validator'],
	props: {
		value: {
			type: String
		},
		name: {
			type: String
		},
		placeholder: {
			type: String
		},
		rules: {
			type: String
		},
		autocomplete: {
			type: String,
			default: ''
		}
	},
	computed: {
		model: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('input', value)
			}
		},
		inputClass () {
			return {
				error: this.errors.has(name)
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/InputText.vue